var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({class:['button',
                 {'button_full': _vm.full},
                 {'button_icon': _vm.icon},
                 {'button_icon-left': _vm.iconLeft},
                 {'button_left': _vm.iconArrowLeft},
                 {'button_small': _vm.small},
                 {'button_outline': _vm.outline},
                 {'is-disabled': _vm.disabled},
                 {'is-hide': _vm.hide},
                 {'is-loading': _vm.loading}]},_vm.$listeners),[_c('span',{staticClass:"button__content"},[(_vm.iconArrowLeft)?[_c('IconArrowLeft')]:_vm._e(),(_vm.iconArrowRight)?[_c('IconArrowRight')]:_vm._e(),(_vm.iconArrowTop)?[_c('IconArrowTop',{staticClass:"icon_white"})]:_vm._e(),(_vm.iconArrowBottom)?[_c('IconArrowBottom',{staticClass:"icon_white"})]:_vm._e(),(_vm.$slots['default'])?_c('span',{staticClass:"button__title"},[_vm._t("default")],2):_vm._e()],2)])}
var staticRenderFns = []

export { render, staticRenderFns }